/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
export type TemplateQuoteSubscriptionStatus_QuoteTemplateFragment = { __typename: 'QuoteTemplate', id: string, templateSharing?: { __typename: 'TemplateSharing', id: string, latestSharedVersionNumber: number, sharedPublicly: boolean, subscribedToTemplate?: { __typename: 'TemplateSubscription', subscribedVersionNumber: number, updateAvailable: boolean } | null } | null };

export const TemplateQuoteSubscriptionStatus_QuoteTemplateFragmentDoc = gql`
    fragment TemplateQuoteSubscriptionStatus_QuoteTemplate on QuoteTemplate {
  id
  templateSharing {
    id
    latestSharedVersionNumber
    sharedPublicly
    subscribedToTemplate {
      subscribedVersionNumber
      updateAvailable
    }
  }
}
    `;